<template>
    <tr v-bind="$attrs" v-on="$listeners">
        <slot v-for="(col, key) in columns" :name="'row-cell-' + col.field" :row="row" :col="col">
            <oc-table-cell
                v-if="$parent.isVisible(col)"
                v-bind="getCellAttrs(col, row, index)"
                @click="$_onRowClick(row, col, index)"
            >
                <component
                    v-if="col.content.component && ! col.type"
                    :is="col.content.component"
                    v-bind="$parent.getEntityOptions('content', col, row, index).options"
                    v-on="$parent.getEntityEvents('content', col, row, index)"
                />
                <oc-plugin-slot
                    v-else
                    name="row-cell"
                    v-bind="$parent.getEntityOptions('content', col, row, index)"
                    v-on="$parent.getEntityEvents('content', col, row, index)"
                    ref="rowCell"
                />
            </oc-table-cell>
        </slot>
    </tr>
</template>

<script>
import {processFilters} from '@/helpers/Utils'

export default {
    name: 'oc-table-row',
    props: {
        onRowClick: {
            type: [Function, Boolean],
            default: false
        },
        columns: {
            type: Array,
            default: () => {
                return []
            }
        },
        row: {
            type: Object,
            default: () => {
                return {}
            }
        },
        index: {
            type: [String, Number]
        }
    },
    methods: {
        $_onRowClick(row, col, index) {
            if( false !== this.onRowClick && true !== col.denyCellClick ) {
                this.onRowClick(row, col, index)
            }
        },
        getCellAttrs(col, row, index) {
            let attrs = {
                field: col.field,
                escapeContent: col.escapeContent,
                content: processFilters(row[col.field], col.format, true, [row])
            }

            if( col.useContentOptions || (col.type === undefined && col.content.component === undefined) ) {
                attrs = Object.assign(attrs, this.$parent.getEntityOptions('content', col, row, index).options)
            }

            attrs.class = Vue.filter('mergeClassExpression')([attrs.class], ['text-break'])

            if( true !== col.denyCellClick && this.onRowClick !== false ) {
                attrs.class = Vue.filter('mergeClassExpression')([attrs.class], ['has-row-click'])
            }

            return attrs
        }
    }
}
</script>

<style scoped>
    .has-row-click{ cursor: pointer; }
</style>
